import { Chip } from '@mui/material';
import dayjs from 'dayjs';
import { AudioFileItem } from '@aviation/cabinapp-cabincast-sdk';

export type AudioFileStatus = 'Disabled' | 'Conditional' | 'All flights';

/** Disabled when switched off or expired, otherwise "Conditional" if condition sets exist and "All flights" if not. */
export function getAudioFileStatus(file: Pick<AudioFileItem, 'Enabled' | 'ValidTo' | 'Conditions'>): AudioFileStatus {
    // ValidTo is a date (YYYY-MM-DD) and is valid through the end of that day.
    const expired = !!file.ValidTo && dayjs(file.ValidTo).endOf('day').isBefore(dayjs());
    if (!file.Enabled || expired) return 'Disabled';
    return (file.Conditions?.length ?? 0) > 0 ? 'Conditional' : 'All flights';
}

export interface IAudioFileStatusChipProps {
    file: Pick<AudioFileItem, 'Enabled' | 'ValidTo' | 'Conditions'>;
}

function AudioFileStatusChip({ file }: IAudioFileStatusChipProps) {
    const status = getAudioFileStatus(file);
    return <Chip size='small' label={status} color={status === 'Disabled' ? 'error' : 'success'} />;
}

export default AudioFileStatusChip;
